export const iconFontAwesomeMedicalHealthClockRotateLeft = (
	<i className="fa-solid fa-clock-rotate-left"></i>
);
